import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom"
import {
  Card,
  Col,
  Row,
  Skeleton,
  Spin,
  Tooltip,
} from "antd";
import BedRooms from "../../assets/images/bed.svg";
import BathTab from "../../assets/images/bathTap.svg";
import Place from "../../assets/images/place.svg";
import { Hidden } from '@material-ui/core';

function Index(props) {
  const personalised = props.match.params.personalised
  const [listings, setListings] = useState(null)

  useEffect(() => {
    fetchPersonalised(personalised)
    window.scrollTo(0, 0)
  },
    [personalised])

  const fetchPersonalised = async (personalised) => {
    var config = {
      method: 'get',
      url: `${process.env.REACT_APP_ORIGIN}api/v1/public/misc/label/properties/${personalised}`,
      headers: {
        'Content-Type': 'application/json'
      }
    };

    axios(config)
      .then(function (response) {
        if (response.data.status === 404) {
          setListings([])
        } else {
          setListings(response.data)
        }
      })
      .catch(function (error) {
        setListings([])
      })
  };

  const numberFormat = (value) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
    }).format(value);
  }

  return (
    <>
      <Helmet>
        <title>{personalised} Vacation Rentals</title>
        <meta name="title" content={`${personalised} Vacation Rentals`} />
        <meta
          name="description"
          content="Roamhome is a rental portal that provides curated homes with professional service. Our properties are spread across budgets without compromising our service."
        />
      </Helmet>
      {/** Mobile Website */}
      <Hidden smUp>
        <div className='mobileSegment'>
          <div className='containerMobile'>
            {listings == null && (
              <div className="loading">
                <Spin size={"large"} />
              </div>
            )}
            {listings !== null && listings.length !== 0 && (

              <div className='listingsContent'>
                <div className='listingsLabel'>
                  {personalised} Vacation rentals
                </div>
              </div>
            )}

            

            <div className='listingsCardsWrapper'>
              {listings !== null && (
                <>
                {listings.length !== 0 && (
                  <div className='listingsCards'>
                    {listings.map((item, idx) => (
                      <div className='listingCard'>
                        <Link key={idx} rel="noopener noreferrer" to={`/desc/${item.listing_id}${personalised === "The Barn" ? "?referal=THEBARN" : ""}`}>
                          <div className='contentContainer'>
                            <div className='imageBox'>
                              <img src={item.featured_img[0].img_480[0].url} />
                            </div>
                            <div className='locationBox'>
                              {item.city}, {item.state}
                            </div>
                            <div className='propertyName'>
                              {item.property_title}
                            </div>
                            <div className='priceNight'>
                              {numberFormat(item.price_night)} / night
                            </div>
                          </div>
                        </Link>
                      </div>
                    ))}
                  </div>
                )}

                {listings.length === 0 && (
                  <div className='emptyListings'>
                    No Homes available for this search right now!
                  </div>
                )}
                </>
              )}
            </div>
          </div>
        </div>
      </Hidden>

      {/** Desktop Website */}
      <Hidden xsDown>

        <div
          className="container"
          style={{ position: "relative" }}
        >
          <Row
            style={{ marginTop: "2rem" }}
            justify="space-between"
            align="middle"
          >
            <h1 style={{ marginBottom: 0 }}>
              {listings !== null && listings.length !== 0 && (
                `${personalised} Vacation rentals`
              )}
            </h1>
            <br />
            <br />
            {listings !== null && (
              <>
                {listings.length === 0 && (
                  <h1>No Properties found for this search!</h1>

                )}
              </>
            )}
            <div
              className="selections-card-wrapper"
              style={{
                marginTop: "1rem",
                marginBottom: "6rem",
                zIndex: 4,
                position: "relative"
              }}
            >
              {listings === null && (
                <>
                  <Col>
                    <Row>
                      <div className="skeleton-row">
                        <Skeleton className="skel" active />
                        <Skeleton className="skel" active />
                        <Skeleton className="skel" active />
                      </div>
                    </Row>
                    <Row>
                      <div className="skeleton-row">
                        <Skeleton className="skel" active />
                        <Skeleton className="skel" active />
                        <Skeleton className="skel" active />
                      </div>
                    </Row>
                    <Row>
                      <div className="skeleton-row">
                        <Skeleton className="skel" active />
                        <Skeleton className="skel" active />
                        <Skeleton className="skel" active />
                      </div>
                    </Row>
                    <Row>
                      <div className="skeleton-row">
                        <Skeleton className="skel" active />
                        <Skeleton className="skel" active />
                        <Skeleton className="skel" active />
                      </div>
                    </Row>
                  </Col>
                </>
              )}

              {listings !== null && (
                <>

                  {listings.length !== 0 && (
                    listings.map((x, i) => (
                      <Link key={x.listing_id} rel="noopener noreferrer" to={`/desc/${x.listing_id}${personalised === "The Barn" ? "?referal=THEBARN" : ""}`}>
                        <Card
                          key={i}
                          className="selection-card"
                          style={{
                            boxShadow: "2.5px 1.5px 3px 0 rgba(0, 0, 0, 0.16)",
                          }}
                          cover={
                            <div className="fav_img">
                              <img
                                src={
                                  x.featured_img[0].img_960[0]
                                    ? x.featured_img[0].img_960[0].url
                                    : ""
                                }
                                alt="selection"
                              />
                              {/*favourites === true ? (
                                        <div className="heart_icon">
                                          <img
                                            src={HeartFilled}
                                            alt="HeartBorder"
                                            onMouseEnter={() => setClick(true)}
                                            onMouseLeave={() => setClick(false)}
                                            onClick={() => handleFavorite(x.listing_id)}
                                          />
                                        </div>
                                      ) : (
                                        <div className="heart_icon">
                                          <img
                                            src={HeartBorder}
                                            alt="HeartBorder"
                                            onMouseEnter={() => setClick(true)}
                                            onMouseLeave={() => setClick(false)}
                                            onClick={() => handleFavorite(x.listing_id)}
                                          />
                                        </div>
                                      )*/}
                            </div>
                          }
                        >
                          <div className="name_rating">
                            <Tooltip title={x.property_title}>
                              <h3>{x.property_title}</h3>
                            </Tooltip>

                            {/* <p>
                                    {x.rating}
                                    <StarFilled className="star_icon" />
                                  </p> */}
                          </div>
                          <p className="place_name">
                            {x.city && (
                              <>
                                <span>{x.city},</span>
                                {""}
                                <span> {x.state}</span>
                              </>
                            )}
                            {!x.city && (
                              <>
                                <span>{x.state},</span>
                                {""}
                                <span> {x.country}</span>
                              </>
                            )}
                          </p>
                          <Row style={{ marginBottom: "5px" }}>
                            {" "}
                            <Col span={8}>
                              {" "}
                              <div className="card_img_icon_svg">
                                <img src={Place} alt="bed" />
                              </div>
                              <p className="name_icon">
                                {x.type_property}
                              </p>
                            </Col>
                            <Col span={8}>
                              <div className="card_img_icon_svg">
                                <img src={BedRooms} alt="Bedrooms" />
                              </div>
                              <p className="name_icon">{x.num_of_bedroom} {(x.num_of_bedroom > 1) ? "Bedrooms" : "Bedroom"}</p>
                            </Col>
                            <Col span={8}>
                              <div className="card_img_icon_svg">
                                <img src={BathTab} alt="bathTub" />
                              </div>
                              <p className="name_icon">{x.num_of_bath} {(x.num_of_bath > 1) ? "Bathrooms" : "Bathroom"}</p>
                            </Col>
                          </Row>
                          <div className="d-flex">
                            {personalised === "Discounted" && (
                              <>
                                <del style={{
                                  "color": "#888787",
                                  "fontSize": "0.8rem"
                                }}>
                                  <p>
                                    {numberFormat(parseInt(x.price_night) * 1.2)}
                                  </p>
                                </del>
                                <p>
                                  &nbsp;
                                </p>
                              </>
                            )}
                            <h4>
                              {numberFormat(x.price_night)}
                            </h4>
                            <b className="fonts"> /night</b>
                          </div>
                          {/* </Link> */}
                        </Card>
                      </Link>
                    ))
                  )}
                </>
              )}

            </div>
          </Row>
        </div>
      </Hidden>
    </>
  )
}

export default Index
